import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Chevron } from './Fleche';
import { useLangue } from '../i18n/LangueContext';

const Entete = () => {
  const { t, langue, changerLangue } = useLangue();
  const [ouvert, setOuvert] = useState(null);
  const [tiroir, setTiroir] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const refNav = useRef(null);

  const menus = [
    { id: 'projets', label: t.nav.projets, liens: t.menus.projets, carte: t.menus.projetsCarte },
    { id: 'partenaire', label: t.nav.partenaire, liens: t.menus.partenaire, carte: t.menus.partenaireCarte }
  ];

  useEffect(() => {
    const surClic = (e) => {
      if (refNav.current && !refNav.current.contains(e.target)) setOuvert(null);
    };
    const surTouche = (e) => {
      if (e.key === 'Escape') {
        setOuvert(null);
        setTiroir(false);
      }
    };
    document.addEventListener('click', surClic);
    document.addEventListener('keydown', surTouche);
    return () => {
      document.removeEventListener('click', surClic);
      document.removeEventListener('keydown', surTouche);
    };
  }, []);

  useEffect(() => {
    document.body.style.overflow = tiroir ? 'hidden' : '';
  }, [tiroir]);

  const survolPossible = () => window.matchMedia('(hover:hover)').matches;

  const allerVers = (cible) => (e) => {
    if (e) e.preventDefault();
    setOuvert(null);
    setTiroir(false);
    if (cible.startsWith('/#')) {
      const id = cible.slice(2);
      if (location.pathname === '/') {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        else window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        navigate('/', { state: { ancre: id } });
      }
    } else {
      navigate(cible);
    }
  };

  const Bascule = ({ classe = '' }) => (
    <div className={`langues ${classe}`} role="group" aria-label={t.nav.langue}>
      {['fr', 'en'].map((l) => (
        <button
          key={l}
          type="button"
          className="langue"
          aria-pressed={langue === l}
          onClick={() => changerLangue(l)}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );

  return (
    <>
      <header className="entete">
        <div className="entete-in">
          <Link to="/" className="marque" onClick={() => setTiroir(false)}>
            <span className="point" aria-hidden="true" />
            Datasectoriel
          </Link>

          <nav className="nav" aria-label={t.nav.projets} ref={refNav}>
            {menus.map((m) => (
              <div
                key={m.id}
                className={`nav-item${ouvert === m.id ? ' ouvert' : ''}`}
                onMouseEnter={() => survolPossible() && setOuvert(m.id)}
                onMouseLeave={() => survolPossible() && setOuvert(null)}
              >
                <button
                  className="nav-btn"
                  aria-expanded={ouvert === m.id}
                  onClick={(e) => {
                    e.stopPropagation();
                    setOuvert(ouvert === m.id ? null : m.id);
                  }}
                >
                  {m.label}
                  <Chevron />
                </button>
                <div className="panneau">
                  <div className="panneau-liens">
                    {m.liens.map((l) => (
                      <a key={l.titre} href={l.to} onClick={allerVers(l.to)}>
                        <strong>{l.titre}</strong>
                        <span>{l.desc}</span>
                      </a>
                    ))}
                  </div>
                  <a href={m.carte.to} className="panneau-carte" onClick={allerVers(m.carte.to)}>
                    <span className="eti">{m.carte.eti}</span>
                    <p>{m.carte.texte}</p>
                  </a>
                </div>
              </div>
            ))}
            <a href="/#activites" className="nav-btn" onClick={allerVers('/#activites')}>{t.nav.activites}</a>
          </nav>

          <div className="entete-fin">
            <Bascule />
            <Link to="/demander-un-acces" className="btn btn-plein btn-petit">{t.nav.acces}</Link>
            <button
              className="burger"
              aria-label={t.nav.ouvrir}
              aria-expanded={tiroir}
              onClick={() => setTiroir(true)}
            >
              <span />
            </button>
          </div>
        </div>
      </header>

      <div className={`tiroir${tiroir ? ' ouvert' : ''}`}>
        <div className="tiroir-tete">
          <Link to="/" className="marque" onClick={() => setTiroir(false)}>
            <span className="point" aria-hidden="true" />
            Datasectoriel
          </Link>
          <div style={{ display: 'flex', alignItems: 'center', gap: '.6rem' }}>
            <Bascule />
            <button className="fermer" aria-label={t.nav.fermer} onClick={() => setTiroir(false)}>&times;</button>
          </div>
        </div>
        <h4>{t.nav.projets}</h4>
        {t.menus.projets.map((l) => (
          <a key={l.to + l.titre} className="lien" href={l.to} onClick={allerVers(l.to)}>{l.titre}</a>
        ))}
        <h4>{t.nav.partenaire}</h4>
        {t.menus.partenaire.slice(0, 2).map((l) => (
          <a key={l.to + l.titre} className="lien" href={l.to} onClick={allerVers(l.to)}>{l.titre}</a>
        ))}
        <a href="/demander-un-acces" className="btn btn-plein" onClick={allerVers('/demander-un-acces')}>
          {t.nav.accesLong}
        </a>
      </div>
    </>
  );
};

export default Entete;
